module.exports = __webpack_public_path__ + "img/orcid_id.274570e8.png";